import script from "./DownloadVue.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadVue.vue?vue&type=script&setup=true&lang=js"

import "./DownloadVue.vue?vue&type=style&index=0&id=ade762de&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ade762de"]])

export default __exports__